import React, { Component } from 'react';
import ReactModal from 'react-modal';
import {
  CloseButton,
  ModalBody,
  ModalWrapper,
} from './InterstitialModal.styles.js';
import { CloseButtonIcon } from '../../Modal/Modal.js';
export default class InterstitialModal extends Component {
  render() {
    const { children, actionButtons, showModal, closeHandler } = this.props;
    return (
      <ModalWrapper id="interstitialModalWrapper">
        <ReactModal
          parentSelector={() => document.querySelector('#interstitialModalWrapper')}
          isOpen={showModal}
          contentLabel="Shopping information"
          onRequestClose={closeHandler}
          className="contentStyles"
          overlayClassName="overlayStyles"
          showClose={true}
        >
          <CloseButton onClick={closeHandler}>
            <CloseButtonIcon title="Close" />
          </CloseButton>
          <ModalBody>{children}</ModalBody>
          <footer>{actionButtons}</footer>
        </ReactModal>
      </ModalWrapper>
    );
  }
}
